<template>
	<component :is="wrapperElement" v-if="link" class="c-logo" :class="'c-logo--' + variant + ' ' + extra">
		<a :href="link" v-if="variant === 'with-text'">
			<span class="c-logo__text t-text-style-mu">{{text}}</span>
			<img src="/gui/images/mkb-logo.svg" class="c-logo__image" width="70" height="17" alt="" aria-hidden="true" />
		</a>
		<a :href="link" v-else>
			<img src="/gui/images/mkb-logo.svg" class="c-logo__image" width="162" height="47" alt="Till startsidan" />
		</a>
	</component>
	<component :is="wrapperElement" v-else class="c-logo" :class="'c-logo--' + variant" :extra="extra">
		<div v-if="variant === 'with-text'">
			<span class="c-logo__text t-text-style-mu">{{text}}</span>
			<img src="/gui/images/mkb-logo.svg" class="c-logo__image" width="70" height="17" alt="" aria-hidden="true"/>
		</div>
		<div v-else>
			<img src="/gui/images/mkb-logo.svg" class="c-logo__image" width="162" height="47" :alt="text" />
		</div>
	</component>
</template>

<script>
export default {
	name: 'VLogo',
	props: {
		variant: {
			type: String,
			default: 'default'
		},
		text: {
			type: String,
			default: ''
		},
		wrapperElement: {
			type: String,
			default: 'div'
		},
		extra: {
			type: String,
			default: ''
		},
		link: {
			type: String,
			default: ''
		}
	}
}
</script>
